import React from 'react';
import './index.css';

export default function PageTitle(props){
    return(
        <p className='view-title'>{props.title}</p>
    )
}